import React from 'react';
import PropTypes from 'prop-types';

const InfoRegionBlock = ({ label, html }) => (
  <div className="airline__info-region__block">
    <div className="airline__info-region__block__label">{label}</div>
    <div
      className="airline__info-region__block__content"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  </div>
);

InfoRegionBlock.propTypes = {
  label: PropTypes.string.isRequired,
  html: PropTypes.string.isRequired,
};

export default InfoRegionBlock;
